/**
 * OFStatePanel - Painel de estados das OFs
 * Extraído de GestaoOFs.js para melhor modularidade
 */
import React from 'react';
import { Card } from '../../ui/card';
import { FileText, CheckCircle, Clock, Play, Pause, Check, XCircle } from 'lucide-react';

const STATUS_CONFIG = {
  rascunho: { label: 'Rascunho', color: 'bg-stone-100 text-stone-600', icon: FileText },
  pendente: { label: 'Ready to Start', color: 'bg-blue-100 text-blue-600', icon: CheckCircle },
  aguardar_entrada: { label: 'Aguardar Entrada', color: 'bg-amber-100 text-amber-600', icon: Clock },
  em_curso: { label: 'Em Curso', color: 'bg-green-100 text-green-600', icon: Play },
  pausado: { label: 'Pausado', color: 'bg-orange-100 text-orange-600', icon: Pause },
  terminado: { label: 'Terminado', color: 'bg-emerald-100 text-emerald-600', icon: Check },
  cancelado: { label: 'Cancelado', color: 'bg-red-100 text-red-600', icon: XCircle },
};

export default function OFStatePanel({
  ofsPorEstado,
  filterStatus,
  setFilterStatus,
}) {
  return (
    <div className="mb-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-4" data-testid="painel-estados">
      {Object.entries(STATUS_CONFIG).map(([status, config]) => {
        const Icon = config.icon;
        const count = ofsPorEstado[status]?.count || 0;
        return (
          <Card 
            key={status} 
            className={`p-4 cursor-pointer transition-all hover:shadow-lg ${filterStatus === status ? 'ring-2 ring-primary' : ''}`}
            onClick={() => setFilterStatus(filterStatus === status ? '' : status)}
            data-testid={`state-card-${status}`}
          >
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-full ${config.color}`}>
                <Icon className="h-5 w-5" />
              </div>
              <div>
                <p className="text-2xl font-bold">{count}</p>
                <p className="text-xs text-stone-500">{config.label}</p>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
}
